import { DMS_MODULE } from './constants';
import { router } from './router';

export const OjeteVozyExternal = {
	name: DMS_MODULE,
	router,
};
